/**
 * ShareLink Component
 *
 * Handles the logic for sharing a URL via the Web Share API on mobile
 * or copying it to the clipboard on desktop.
 */
import { showSuccessNotyf, showErrorNotyf } from "../utils/notyf-helpers.js";

export class ShareLink {
  constructor(selector = ".share-this-btn") {
    this.buttons = document.querySelectorAll(selector);
    if (this.buttons.length > 0) {
      this._bindEvents();
    }
  }

  _bindEvents() {
    this.buttons.forEach((button) => {
      button.addEventListener("click", (event) => this._handleClick(event));
    });
  }

  _handleClick(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const urlToShare = button.dataset.url;
    const shareTitle = button.dataset.title;

    if (this._isMobileDevice() && navigator.share) {
      this._webShare(shareTitle, urlToShare);
    } else {
      this._copyToClipboard(urlToShare);
    }
  }

  _webShare(title, url) {
    navigator
      .share({ title, url })
      .then(() => {
        // Use standardized notification system
        if (typeof mpsString !== "undefined" && mpsString.share_success) {
          showSuccessNotyf(mpsString.share_success);
        } else {
          showSuccessNotyf("Successfully shared");
        }
      })
      .catch((error) => {
        console.error("Sharing failed", error);
        if (typeof mpsString !== "undefined" && mpsString.share_fail) {
          showErrorNotyf(mpsString.share_fail);
        } else {
          showErrorNotyf("Sharing failed");
        }
      });
  }

  _copyToClipboard(url) {
    navigator.clipboard
      .writeText(url)
      .then(() => {
        if (typeof mpsString !== "undefined" && mpsString.copy_url_success) {
          showSuccessNotyf(mpsString.copy_url_success);
        } else {
          showSuccessNotyf("URL copied to clipboard");
        }
      })
      .catch(() => {
        if (typeof mpsString !== "undefined" && mpsString.copy_url_fail) {
          showErrorNotyf(mpsString.copy_url_fail);
        } else {
          showErrorNotyf("Failed to copy URL");
        }
      });
  }

  _isMobileDevice() {
    return (
      typeof window.orientation !== "undefined" || navigator.userAgent.indexOf("IEMobile") !== -1
    );
  }
}
